import { HttpParams } from '@angular/common/http'
import { Component, OnDestroy, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { AllowDragging } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, MeetingPage, MeetingPageTypeEx, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { MeetingPageComponent } from './meeting-page.component'

@Component({
    selector: 'app-meeting-pages',
    templateUrl: './meeting-pages.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarButtonsComponent, WjGridModule, AutoSizeDirective, WjGridFilterModule],
})
export class MeetingPagesComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch

    meetingId = input.required<string>()
    active = input.required<number>()

    grid: Grid<MeetingPage>

    pageTypeMap = MeetingPageTypeEx.toDataMap()

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.MeetingsMeetingEdit])
    }

    constructor() {
        super()

        effect(() => {
            if (this.active() == 7) {
                this.refreshMeetingPages()
            }
        })

        this.grid = new Grid<MeetingPage>(this.services)
            .setupModalEditing(
                this.services.data.meetingPage,
                'Page',
                MeetingPageComponent,
                () => new MeetingPage(),
                this,
                ModalSize.medium,
            )
            .allowDragging(AllowDragging.Both)

        const reordered = () => {
            this.meetingsGridReordered()
        }
        this.grid.dragged.on(reordered)
    }

    meetingsGridReordered() {
        const meetings = this.grid.view.items
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.put('/api/MeetingPage/BulkUpdate', meetings)).subscribe({
                next: () => {
                    this.refreshMeetingPages()
                },
            }),
        )
    }

    refreshMeetingPages() {
        const params = new HttpParams().set('meetingId', this.meetingId())
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.meetingPage.queryAllByAction('GetByMeetingId', params)).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result[0]
                },
            }),
        )
    }
}
